/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */
import React, { Fragment } from "react";
import "./GatewayRegistrationSummary.scss";
import Success from "../../../icons/Success.svg";
import {
  ISelectedGateway,
  IFCPDIYGatewayManagementProps,
} from "../../../stores/GatewayManager/IGatewayRegistrationInterfaces";
import { inject } from "mobx-react";

export interface IConfirmGatewaySelectionProps
  extends IFCPDIYGatewayManagementProps {
  selectedGateway: ISelectedGateway;
}

// @observer
// @inject('globalStore')
export const GatewayRegistrationSuccessSummary = (
  props: IConfirmGatewaySelectionProps
) => {
  const contactSupport = () => {
    let envVariables = props.globalStore!.envVariables;
    let emailAdress = envVariables.FCP_SUPPORT_EMAIL_ID;
    return `mailto: ${emailAdress}?subject=Gateway registration is successfully completed.`;
  };

  return (
    <Fragment>
      <div className="application-page-content ui-gateway-selection-container">
        <div className="ui-gateway-selection-title">Setup Complete</div>
        <img src={Success} className="ui-summary-icon" />
        <div className="ui-result-success-summary">
          Gateway registration is successfully completed.
        </div>
        <div className="ui-success-summary">
          <div className="ui-success-summary-title">Summary</div>
          <div className="ui-success-summary-gateway-title">Gateway Name:</div>
          <div className="ui-success-summary-gateway-value">
            {props.selectedGateway.gatewayName}
          </div>
          <div className="ui-success-summary-tenant-title">Tenant:</div>
          <div className="ui-success-summary-tenant-value">
            {props.selectedGateway.tenant}
          </div>
          <div className="ui-success-summary-serial-number-title">
            Serial Number:
          </div>
          <div className="ui-success-summary-serial-number-value">
            {props.selectedGateway.serialNumber}
          </div>
        </div>

        <div className="ui-success-summary-contact">
          <div>
            For further queries, <a href={contactSupport()}>Contact Support.</a>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export const GatewayRegSuccessSummary = inject("globalStore")(
  GatewayRegistrationSuccessSummary
);
